import { PersonOutline } from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';

export const VeranstaltungTrainer = ({ trainers }: { trainers: string[] }) => {
  const text = trainers.join(', ');

  return (
    <Box display="flex" alignItems="center" gap={0.5} overflow="hidden">
      <PersonOutline fontSize="small" sx={{ color: (theme) => theme.palette.text.tertiary }} />
      <Tooltip
        title={text.length === 0 ? 'Kein Trainer gebucht' : text}
        arrow
        disableInteractive
        placement="bottom-start"
      >
        <Typography variant="labelSmLight" color="textTertiary" noWrap>
          {text.length === 0 ? '-' : text}
        </Typography>
      </Tooltip>
    </Box>
  );
};
